import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import Spacing from "../Spacing";
import { fetchAllUsers } from "../../services/users";
import { notify } from "../../helpers";
import { AddAndUpdatePasswordManager } from "../../services/passwordManager";
import { Loader } from "lucide-react";
import { Drawer } from 'vaul';
const shareGif = './images/share.gif';

export default function SharePasswordModal({ 
  shareValue = null,
  account_id = "",
  location_id = "",
  user_id = "",
  activeModal = false,
  setActiveModal = () => {},
  reloadDataFilter = {},
  reloadData = () => {},
  previousScrollPosition = 0,
}) {
  const dropdownRef = useRef(null);
  const [practiceUsers, setPracticeUsers] = useState([]);
  const [submitLoader, setSubmitLoader] = useState(false);

  const defaultValues = {
    account_id: account_id,
    location_id: location_id,
    created_by: user_id,
    title: shareValue?.title ? shareValue?.title : "",
    username: shareValue?.username ? shareValue?.username : "",
    password: shareValue?.password ? shareValue?.password : "",
    portal_url: shareValue?.portal_url ? shareValue?.portal_url : "",
    location_ids: shareValue?.location_ids ? shareValue?.location_ids : [location_id],
    share_with: shareValue?.share_with ? shareValue?.share_with : [],
    note: shareValue?.note ? shareValue?.note : "",
    everyone: shareValue?.everyone ? shareValue?.everyone : false
  }
  const [formData, setFormData] = useState(defaultValues);

  const [filter] = useState({
    page: 1,
    per_page: 500,
    location_id: location_id,
    account_id: account_id,
    search_term: "",
    order_by: [],
  });

  const getAllUserss = async (filterData, accountId, locationId) => {
    try {
      const response = await fetchAllUsers( filterData, accountId, locationId );
      if (response?.data) {
        const allUsers = response?.data?.results?.map((option) => ({
          value: option?.id,
          label: option?.first_name+' '+option?.last_name,
        }))
        setPracticeUsers(allUsers);
      };
    } catch (error) {
      // console.log("🚀 ~ getAllUsers: ~ error:", error);
    }
  };

  useEffect(() => {
    getAllUserss(filter, account_id, location_id);
  }, [filter, account_id, location_id]);

  const handleUserChange = (selectedOption) => {
    const selectedValues = selectedOption.map((option) => option.value);
    setFormData({
      ...formData,
      share_with: selectedValues,
      everyone: selectedValues.length > 0 ? false : formData.everyone,
    });
  };
  
  const handleSwitchChange = (e) => {
    const isChecked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      everyone: isChecked,
      share_with: isChecked ? [] : prev.share_with,
    }));
  };

  const handelShareSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoader(true);

    try {
      const response = await AddAndUpdatePasswordManager(formData);
    
      if (response.detail) {
        notify('error', response.detail, 0.5);
      } else { 
        if(response?.data?.status === "success") {
          notify("success", response?.data?.message, 0.5);
          setFormData(defaultValues);
          reloadData(reloadDataFilter);     
          handleDrawerClose();
        } else {
          notify("error", response?.data?.message, 0.5);
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 1);
      }
    } finally {
      setSubmitLoader(false);
    }
  }

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };
  
  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 medium">
            <Drawer.Title className="sr-only">Share Password</Drawer.Title>
            <Drawer.Description className="sr-only">Share password details</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal">
                <div className="docpro_deleteboxbox">
                  <img
                    src={shareGif}
                    alt=""
                    width={120}
                    height={120}
                  />
                  <Spacing lg="20" sm="20" />

                  <form onSubmit={handelShareSubmit}>
                    <div className="docpro_iconbox_right">
                      <h3 className="docpro_fs_20">Share</h3>
                      <p className="docpro_mb_0 docpro_fs_16"> Share password with </p>
                      <Spacing lg="10" sm="10" />

                      <div style={{ textAlign: 'left' }}>
                      <Select
                        isMulti
                        name="share_with"
                        options={practiceUsers}
                        placeholder="Search..."
                        isSearchable
                        value={practiceUsers?.filter((option) => 
                          formData.share_with?.includes(option.value)
                        ) || []}
                        onChange={handleUserChange}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        filterOption={(option, rawInput) => {
                          const words = rawInput.toLowerCase().split(" ");
                          return words.every((word) =>
                            option.label.toLowerCase().includes(word)
                          );
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '40px',
                            borderColor: 'var(--border)',
                            borderRadius: '8px'
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 1050,
                            marginTop: '-2px',
                            borderRadius: '0 0 3px 3px',
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 1050,
                            padding: 0
                          }),
                        }}
                      />
                      </div>
                      <Spacing lg="15" sm="15" />
                      <div className="flex items-center" style={{ justifyContent: 'center' }}>
                        <label className="switch mb-0 mr-2">
                          <input
                            type="checkbox"
                            name="everyone"
                            checked={formData?.everyone}
                            onChange={handleSwitchChange}
                          />
                          <span className="slider round"></span>
                        </label>
                        <span>Everyone</span>
                      </div>

                      <Spacing lg="32" sm="32" />
                      <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                        <button
                          type="button"
                          className="docpro_bordered_btn docpro_fw_600 size_lg"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleDrawerClose();
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                          disabled={submitLoader ? true : false}
                        >
                          <span>Save</span>
                          {submitLoader && (
                            <span className="docpro_loading">
                              <Loader width={20} height={20} />
                            </span>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
